import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './context/AuthContext';
import { LanguageProvider } from './context/LanguageContext';
import { ThemeProvider } from './context/ThemeContext';
import PrivateRoute from './components/PrivateRoute';
import Layout from './components/Layout/Layout';

// Lazy load pages
const LandingPage = lazy(() => import('./pages/LandingPage'));
const RegisterPage = lazy(() => import('./pages/RegisterPage'));
const DashboardPage = lazy(() => import('./pages/DashboardPage'));
const AnimalsPage = lazy(() => import('./pages/AnimalsPage'));
const AnimalDetailPage = lazy(() => import('./pages/AnimalDetailPage'));
const HealthPage = lazy(() => import('./pages/HealthPage'));
const MilkPage = lazy(() => import('./pages/MilkPage'));
const FinancePage = lazy(() => import('./pages/FinancePage'));
const TasksPage = lazy(() => import('./pages/TasksPage'));
const ReproductionPage = lazy(() => import('./pages/ReproductionPage'));
const ReportsPage = lazy(() => import('./pages/ReportsPage'));
const InventoryPage = lazy(() => import('./pages/InventoryPage'));
const SettingsPage = lazy(() => import('./pages/SettingsPage'));

const PageLoader = () => (
  <div className="flex items-center justify-center h-64">
    <div className="w-8 h-8 border-4 border-green-600 border-t-transparent rounded-full animate-spin" />
  </div>
);

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <ThemeProvider>
          <Router>
          <Suspense fallback={<PageLoader />}>
            <Routes>
              <Route path="/login" element={<LandingPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/" element={<LandingPage />} />

              <Route element={<PrivateRoute />}>
                <Route element={<Layout />}>
                  <Route path="/dashboard" element={<DashboardPage />} />
                  <Route path="/animals" element={<AnimalsPage />} />
                  <Route path="/animals/:id" element={<AnimalDetailPage />} />
                  <Route path="/health" element={<HealthPage />} />
                  <Route path="/milk" element={<MilkPage />} />
                  <Route path="/finance" element={<FinancePage />} />
                  <Route path="/tasks" element={<TasksPage />} />
                  <Route path="/reproduction" element={<ReproductionPage />} />
                  <Route path="/reports" element={<ReportsPage />} />
                  <Route path="/inventory" element={<InventoryPage />} />
                  <Route path="/settings" element={<SettingsPage />} />
                </Route>
              </Route>
            </Routes>
          </Suspense>
          </Router>
          <Toaster position="top-right" toastOptions={{ duration: 3000 }} />
        </ThemeProvider>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
